/* eslint-disable import/prefer-default-export */

// TODO: Create global window interface.
declare const window: any;

export const assetUrl = 'https://static.coconutcalendar.com/';
export const coconutPrimaryColour = '#2979FF'; // Material-UI's blue A[400]
export const drawerOpenWidth = 240;
export const drawerClosedWidth = 70;
export const drawerZIndex = 1100;
export const topBarHeight = 64;
export const longNameLength = 15;
export const veryLongNameLength = 50;
export const snackbarDuration = 4000;
export const random = 'random';
export const attendeeSearchMinLength = 2; // Minimum inclusive length to search for clients or staff

export const LOCALES = {
  en: 'en',
  fr: 'fr',
  es: 'es',
  ko: 'ko',
  pl: 'pl',
  pt: 'pt',
  ru: 'ru',
  zh: 'zh',
};
export const randomForLanguage = {
  en: `${random}-en`,
  es: `${random}-es`,
  fr: `${random}-fr`,
  ko: `${random}-ko`,
  pl: `${random}-pl`,
  pt: `${random}-pt`,
  ru: `${random}-ru`,
  zh: `${random}-zh`,
};
export const isRandomForLang = {
  [randomForLanguage.en]: 1,
  [randomForLanguage.es]: 1,
  [randomForLanguage.fr]: 1,
  [randomForLanguage.ko]: 1,
  [randomForLanguage.pl]: 1,
  [randomForLanguage.pt]: 1,
  [randomForLanguage.ru]: 1,
  [randomForLanguage.zh]: 1,
};
export const abbreviatedFormatsWithDays = {
  en: 'd[d] h[h] m[m]',
  es: 'd[d] h[h] m[m]',
  fr: 'd [j] h [h] m[m]',
  ko: 'd[일] h[시간] m[분]',
  pl: 'd[d] h[g] m[m]',
  'pt-br': 'd[d] h[h] m[m]',
  ru: 'd[д] h[ч] m[м]',
  'zh-cn': 'd[天] h[小时] m[分钟]',
};
export const ACTIVITY_TYPES = {
  APPOINTMENTS: 'appointments',
  QUEUE_APPOINTMENTS: 'queue-appointments',
};
export const appointmentStatuses = {
  CONFIRMED: 1,
  STATUS_COMPLETE: 2,
  NO_SHOW: 3,
  CANCELLED: 4,
  IN_PROGRESS: 5,
  SERVED: 6,
};
export const STATUS_NAMES = {
  [appointmentStatuses.CONFIRMED]: 'confirmed',
  [appointmentStatuses.STATUS_COMPLETE]: 'completed',
  [appointmentStatuses.NO_SHOW]: 'no_show',
  [appointmentStatuses.CANCELLED]: 'cancelled',
  [appointmentStatuses.IN_PROGRESS]: 'in_progress',
  [appointmentStatuses.SERVED]: 'served',
};
export const NOTIFIABLE_STATUSES = {
  [appointmentStatuses.CONFIRMED]: true,
  [appointmentStatuses.STATUS_COMPLETE]: true,
  [appointmentStatuses.NO_SHOW]: true,
  [appointmentStatuses.CANCELLED]: true,
  [appointmentStatuses.IN_PROGRESS]: false,
  [appointmentStatuses.SERVED]: false,
};
export const absenceStatuses = {
  CONFIRMED: 1,
  COMPLETE: 2,
  NOSHOW: 3,
  CANCELLED: 4,
};
export const ABSENCE_TYPES = {
  PERSONAL: 1,
  SICK: 3,
  VACATION: 4,
  EXTERNAL: 5,
};
export const unassigned = 'unassigned';
export const headerMessageTypes = {
  info: 'info',
  warning: 'warning',
  noMessage: null,
};
export const attendeeStatuses = {
  CONFIRMED: 1,
  ARRIVED: 2,
  NO_SHOW: 3,
  CANCELLED: 4,
};
export const roles = {
  ALL: 0,
  CALL_CENTRE_STAFF: 5,
  KIOSK: 7,
  STAFF: 10,
  STAFF_PLUS: 13,
  STAFF_ADVANCED: 15,
  MANAGER: 20,
  ADMIN: 30,
  COCONUT_ADMIN: 50,
};

export const SECURE_ROLES = [
  roles.CALL_CENTRE_STAFF,
  roles.STAFF,
  roles.STAFF_PLUS,
  roles.STAFF_ADVANCED,
  roles.MANAGER,
  roles.ADMIN,
];

export const ROLE_LABELS = {
  [roles.CALL_CENTRE_STAFF]: 'Contact Centre Staff',
  [roles.KIOSK]: 'Kiosk',
  [roles.STAFF]: 'Staff',
  [roles.STAFF_PLUS]: 'Staff Plus',
  [roles.STAFF_ADVANCED]: 'Staff Advanced',
  [roles.MANAGER]: 'Manager',
  [roles.ADMIN]: 'Admin',
  [roles.COCONUT_ADMIN]: 'Coconut Admin',
};

export const ROLE_LABELS_FORMAT = {
  [roles.ADMIN]: 'Role.Labels.admin',
  [roles.CALL_CENTRE_STAFF]: 'Role.Labels.call_centre_staff',
  [roles.COCONUT_ADMIN]: 'Role.Labels.coconut_admin',
  [roles.KIOSK]: 'Role.Labels.kiosk',
  [roles.MANAGER]: 'Role.Labels.manager',
  [roles.STAFF]: 'Role.Labels.staff',
  [roles.STAFF_ADVANCED]: 'Role.Labels.staff_advanced',
  [roles.STAFF_PLUS]: 'Role.Labels.staff_plus',
};

export const ACTION_TYPE = {
  Add: 'add',
  Edit: 'edit',
  Delete: 'delete',
};

export const questionTypes = {
  TYPE_TEXT: 1,
  TYPE_SELECT: 2,
  TYPE_CHECKBOX: 3,
  TYPE_RADIO: 4,
  TYPE_TEXTAREA: 5,
  TYPE_UPLOAD: 6,
};
export const attendeeTabs = {
  DETAILS: 0,
  QUESTIONS: 1,
};
export const bookedThrough = {
  UNKNOWN: 0,
  QUEUE: 1,
  CLIENT_VIEW: 2,
  SCHEDULE: 3,
  API: 4,
  WAIT_LIST: 5,
  CALL_CENTRE: 6,
  CONSOLE: 7,
  MODERN_CLIENT_VIEW: 9,
  RESERVE_WITH_GOOGLE: 10,
  LOBBY: 12,
  ONLINE_QUEUE: 13,
  KIOSK: 14,
  DYNAMICS: 16,
  DIGITAL_BANKING_PLATFORM: 17,
  SALESFORCE: 18,
  KIOSK_QR: 20,
};
export const BOOKED_THROUGH_NAMES = {
  [bookedThrough.UNKNOWN]: 'BookedThrough.unknown',
  [bookedThrough.QUEUE]: 'BookedThrough.device',
  [bookedThrough.CLIENT_VIEW]: 'BookedThrough.client_view',
  [bookedThrough.SCHEDULE]: 'BookedThrough.schedule',
  [bookedThrough.API]: 'BookedThrough.wait_list',
  [bookedThrough.WAIT_LIST]: 'BookedThrough.api',
  [bookedThrough.CALL_CENTRE]: 'BookedThrough.call_centre',
  [bookedThrough.CONSOLE]: 'BookedThrough.console',
  [bookedThrough.MODERN_CLIENT_VIEW]: 'BookedThrough.modern_client_view',
  [bookedThrough.RESERVE_WITH_GOOGLE]: 'BookedThrough.reserve_with_google',
  [bookedThrough.LOBBY]: 'BookedThrough.lobby',
  [bookedThrough.ONLINE_QUEUE]: 'BookedThrough.online_queue',
  [bookedThrough.DYNAMICS]: 'BookedThrough.dynamics',
  [bookedThrough.DIGITAL_BANKING_PLATFORM]:
    'BookedThrough.digital_banking_platform',
  [bookedThrough.SALESFORCE]: 'BookedThrough.salesforce',
  [bookedThrough.KIOSK]: 'BookedThrough.kiosk',
  [bookedThrough.KIOSK_QR]: 'BookedThrough.kiosk_qr',
};
export const sections = {
  SERVICE: 1,
  LOCATION: 2,
  USER: 3,
  DATE: 4,
  ATTENDEES: 5,
  ATTENDEE_DETAILS: 6,
  MEETING_METHOD: 7,
};
export const paths = {
  [sections.SERVICE]: '/select-service',
  [sections.LOCATION]: '/select-location',
  [sections.USER]: '/select-staff',
  [sections.DATE]: '/select-timeslot',
  [sections.ATTENDEES]: '/select-attendees',
  [sections.ATTENDEE_DETAILS]: '/attendee-details',
};
export const adjustmentTypes = {
  USER: 1,
  LOCATION: 2,
  HOLIDAY: 3,
  OVERRIDE: 4,
};
export const adjustmentsTypeLabels = {
  [adjustmentTypes.USER]: 'Adjustments.type_staff',
  [adjustmentTypes.LOCATION]: 'Adjustments.type_location',
  [adjustmentTypes.HOLIDAY]: 'Adjustments.type_holiday',
  [adjustmentTypes.OVERRIDE]: 'Adjustments.type_location',
};
export const dataExportStatuses = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  UNAUTHORIZED: 'unauthorized',
};
export const reportEngagementTypes = {
  ALL: 'all',
  APPOINTMENTS: 'appointments',
  WALKINS: 'walkins',
};
export const reportCategories = {
  ALL: 'all',
  UNCATEGORIZED: 'uncategorized',
};
export const reportResourceSelectors = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  SPECIFIC: 'SPECIFIC',
};
export const reportEvents = {
  DATA_EXPORT_STATUS_UPDATE:
    'App\\Domains\\Reporting\\Events\\DataExportStatusUpdated',
};
export const customerTraffic = {
  ALL: 'all',
  ALL_LOCATIONS: 'All Locations',
  CATEGORY: 'category',
  LOCATION: 'location',
  CATEGORIZED_LOCATION: 'categorizedLocation',
};
export const hoursPages = {
  BUSINESS_HOURS: 0,
  WORKING_HOURS: 1,
  ADJUSTMENTS: 2,
};
export const NEW_HOURS_PAGES = {
  OVERVIEW: 0,
  LOCATION_DEFAULTS: 1,
  STAFF_DEFAULTS: 2,
};
export const exchangeSettingsPages = {
  ISSUES: 0,
  STATUS: 1,
  ACCOUNTS: 2,
  CONFIGURATION: 3,
  ACCOUNT_ASSOCIATIONS: 4,
  TOOLS: 5,
};
export const calendarIntegrations = {
  EXCHANGE: 0,
  GSUITE: 1,
  CALENDAR_SYNC: 2,
};
export const calendarIntegrationLabels = {
  [calendarIntegrations.EXCHANGE]: 'exchange',
  [calendarIntegrations.GSUITE]: 'gsuite',
  [calendarIntegrations.CALENDAR_SYNC]: 'two-way sync',
};
export const exchangeResyncProgress = {
  COMPLETED: 'resyncCompleted',
  LAST_UPDATE: 'resyncLastUpdate',
  TOTAL: 'resyncTotal',
};
export const userAccountDialogTypes = {
  LOG: 0,
  DETAILS: 1,
  RESET: 2,
  RESET_ALL: 3,
};
export const defaultShortcutsTabs = {
  PERSONAL: 0,
  SERVICES: 1,
  LOCATIONS: 2,
  MEETING_METHODS: 3,
};
export const addHoursOptions = {
  HOLIDAY: 'holiday',
  ADJUSTMENT: 'adjustment',
};
export const ADJUST = {
  BUSINESS: 'business',
  WORKING: 'working',
};
export const VARIETY_FROM_TYPE = {
  [adjustmentTypes.USER]: ADJUST.WORKING,
  [adjustmentTypes.LOCATION]: ADJUST.BUSINESS,
  [adjustmentTypes.HOLIDAY]: ADJUST.BUSINESS,
  [adjustmentTypes.OVERRIDE]: ADJUST.BUSINESS,
};
export const frequencies = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};
export const frequencyLabels = {
  DAILY: 'Hours.day',
  WEEKLY: 'Hours.week',
  MONTHLY: 'Hours.month',
  YEARLY: 'Hours.year',
};
export const holidayFrequencies = {
  NEVER: 'NEVER',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};
export const holidayFrequencyLabels = {
  NEVER: 'Holidays.never',
  MONTHLY: 'Holidays.monthly',
  YEARLY: 'Holidays.yearly',
};
export const ends = {
  COUNT: 'count',
  NEVER: 'never',
  UNTIL: 'until',
};
export const adjustmentDates = {
  DATE: 'date',
  UNTIL: 'until',
};
export const progressDirection = {
  CONNECT: 'connecting',
  DISCONNECT: 'disconnecting',
};
export const defaultTimezone = 'UTC';
export const midnight = '00:00:00';
export const midnightNextDay = '24:00:00';
export const defaultResource = { id: '0' };
export const adjustmentDateFormat = 'll';
export const exchangeVersion = '2010';
export const firstColourInPicker = '#b80000';
export const ubuntu = 'Ubuntu, sans-serif';
export const arial = 'Arial, sans-serif';
export const helvetica = 'Helvetica, sans-serif';
export const tahoma = 'Tahoma, sans-serif';
export const trebuchetMs = 'Trebuchet MS, sans-serif';
export const verdana = 'Verdana, sans-serif';
export const georgia = 'Georgia, serif';
export const timesNewRoman = 'Times New Roman, serif';
export const fonts = [
  { value: ubuntu, text: ubuntu },
  { value: arial, text: arial },
  { value: helvetica, text: helvetica },
  { value: tahoma, text: tahoma },
  { value: trebuchetMs, text: trebuchetMs },
  { value: verdana, text: verdana },
  { value: georgia, text: georgia },
  { value: timesNewRoman, text: timesNewRoman },
];
export const emailTypes = [
  { value: 1, text: 'Appointment Confirmed - Staff' },
  { value: 2, text: 'Appointment Updated - Staff' },
  { value: 3, text: 'Appointment Cancelled by Client - Staff' },
  { value: 4, text: 'Appointment Cancelled by Client - Client' },
  { value: 5, text: 'Appointment Completed - Client' },
  { value: 6, text: 'Appointment Confirmed - Client' },
  { value: 7, text: 'Appointment Missed - Client' },
  { value: 8, text: 'Appointment Reminder - Client' },
  { value: 9, text: 'Appointment Updated - Client' },
  { value: 11, text: 'Waitlist Confirmed - Client' },
  { value: 12, text: 'Waitlist Confirmed - Staff' },
  { value: 14, text: 'Group Appointment Cancelled - Staff' },
  { value: 15, text: 'Group Appointment Confirmed - Staff' },
  { value: 16, text: 'Group Appointment Updated - Staff' },
  { value: 21, text: 'Advanced Waitlist Confirmed - Client' },
  { value: 22, text: 'Advanced Waitlist Availability - Client' },
  { value: 23, text: 'Advanced Waitlist Confirmed - Staff' },
  { value: 24, text: 'Appointment Cancelled by Staff - Staff' },
  { value: 25, text: 'Appointment Cancelled by Staff - Client' },
];
export const CustomEmailState = {
  PUBLISHED: 0,
  DRAFT: 1,
};
export const CustomEmailStateLabels = {
  [CustomEmailState.PUBLISHED]: 'CustomEmails.published',
  [CustomEmailState.DRAFT]: 'CustomEmails.draft',
};
export const defaultLanguage = 'en';
export const exchangeExpiryStartDays = 14;
export const OFFICE_365_DOMAIN = 'outlook.office365.com';
export const VERSION_2010 = 1;
export const VERSION_2010_SP1 = 2;
export const VERSION_2010_SP2 = 3;
export const VERSION_2013 = 4;
export const VERSION_2013_SP1 = 5;
export const VERSION_2016 = 6;
export const VERSION_OFFICE_365 = 7;
export const VERSION_2019 = 8;
export const exchangeVersions = [
  {
    label: '2010',
    value: VERSION_2010,
  },
  {
    label: '2010 SP1',
    value: VERSION_2010_SP1,
  },
  {
    label: '2010 SP2',
    value: VERSION_2010_SP2,
  },
  {
    label: '2013',
    value: VERSION_2013,
  },
  {
    label: '2013 SP1',
    value: VERSION_2013_SP1,
  },
  {
    label: '2016',
    value: VERSION_2016,
  },
  {
    label: '2019',
    value: VERSION_2019,
  },
  {
    label: 'Office 365',
    value: VERSION_OFFICE_365,
  },
];
export const exchangeAuthTypes = {
  BASIC_NTLM: 'basic',
  OAUTH: 'oauth',
};
export const eventTypes = {
  ABSENCE: 'App\\Models\\Absence',
  APPOINTMENT: 'App\\Models\\Appointment',
  ENGAGEMENT: 'App\\Models\\Engagement',
  WALK_IN: 'App\\Models\\QueueAppointment',
};
export const syncLogStatuses = {
  SUCCESS: 0,
  IN_PROGRESS: 1,
  SCHEDULED: 2,
  ERROR: 3,
  WARNING: 4,
};
export const syncLogActions = {
  CREATE: 0,
  UPDATE: 1,
  DELETE: 2,
};
export const syncLogDirections = {
  EXPORT: 0,
  IMPORT: 1,
};
export const userAccountsPermissionCategories = {
  SYNCING: 1,
  WARNING: 2,
  ERROR: 3,
};
export const userAccountsErrorCodes = {
  ACCESS_DENIED: 'ErrorAccessDenied',
  GRAPH_ACCESS_DENIED: 'AccessDenied',
  EXTENSION_ERROR: 'ExtensionError',
};
export const userAccountsWarningCodes = {
  NON_EXISTENT_MAILBOX: 'ErrorNonExistentMailbox',
  FOLDER_NOT_FOUND: 'ErrorFolderNotFound',
  ITEM_NOT_FOUND: 'ErrorItemNotFound',
  IMPERSONATION_DENIED: 'ErrorImpersonationDenied',
  IMPERSONATION_FAILED: 'ErrorImpersonationFailed',
  IMPERSONATE_USER_DENIED: 'ErrorImpersonateUserDenied',
  RESYNC_REQUIRED: 'ResyncRequired',
  ACTIVITY_LEVEL_REACHED: 'ResyncRequired',
};
export const insightsAggregationUnits = {
  DAY: 'day',
  MONTH: 'month',
  WEEK: 'week',
};
export const queueAppointmentStatuses = {
  CONFIRMED: 1,
  COMPLETE: 2,
  NO_SHOW: 3,
  CANCELLED: 4,
  IN_PROGRESS: 5,
};
export const INVITATION_STEPS = {
  CLIENT: 'client',
  SERVICE: 'service',
  LOCATION: 'location',
  TIMES: 'times',
  SUMMARY: 'summary',
};
export const resourceTypes = {
  ACCOUNT_SYNCING_STATUSES: 'account-syncing-statuses',
  ACTIVITY: 'activities',
  ADJUSTMENT: 'adjustments',
  ANSWER: 'answers',
  APPOINTMENT: 'appointments',
  ATTENDEE: 'attendees',
  BUSINESS_HOURS: 'business-hours',
  CANCELLATION_REASONS: 'cancellation-reasons',
  CATEGORY: 'categories',
  CLIENT: 'clients',
  COUNTRY: 'countries',
  DATATABLE_ADJUSTMENT: 'datatable-adjustments',
  DATA_EXPORT: 'data-export',
  DATA_EXPORT_TEMPLATE: 'data-export-template',
  ENGAGEMENT: 'engagement-resource',
  EXCHANGE_ACCOUNTS: 'exchange-accounts',
  GLIA: 'glia-integration',
  GROUP: 'groups',
  LANGUAGE: 'languages',
  LOCATION: 'locations',
  LOOKER_DASHBOARD: 'looker-dashboard',
  LOOKER_LOOK: 'looker-look',
  MEETING_METHOD: 'meeting-methods',
  LOOKER_EMBED_COPY_LOOK: 'looker-embed-copy-look',
  LOOKER_EMBED_COPY_DASHBOARD: 'looker-embed-copy-dashboard',
  LOOKER_EMBED_EXPLORES: 'looker-embed-explores',
  LOOKER_EMBED_FAVOURITE_CONTENT: 'looker-embed-favourite-content',
  LOOKER_EMBED_ORGANIZATION_CONTENT: 'looker-embed-organization-content',
  LOOKER_EMBED_USER_DASHBOARDS: 'looker-embed-user-dashboards',
  LOOKER_DASHBOARD_URL: 'looker-dashboard-url',
  LOOKER_SSO_EMBED_URL: 'looker-sso-embed-url',
  LOOKER_EMBED_USER_LOOKS: 'looker-embed-user-looks',
  LOOKER_EMBED_SHARED_DASHBOARDS: 'looker-embed-shared-looks',
  LOOKER_EMBED_SHARED_LOOKS: 'looker-embed-shared-looks',
  MICROSOFT_DYNAMICS_INTEGRATION: 'microsoft_dynamics_integration',
  POINT: 'point',
  QUESTION: 'questions',
  QUEUE_APPOINTMENT: 'queue-appointments',
  SCHEDULED_LOOKER_EXPORT: 'scheduled-looker-exports',
  SERVICE: 'services',
  SYNC_LOG_ACTIVITIES: 'sync-log-activities',
  SYNC_LOG_EVENT_DETAILS: 'sync-log-event-details',
  SYNC_LOGS: 'sync-logs',
  USER: 'users',
  ROLE: 'role',
  REGION: 'regions',
  ROOM: 'rooms',
  TAG: 'tags',
  TIMESLOTS: 'time-slots',
  TIMEZONE: 'timezones',
  VENDOR_EXCHNAGE_SETTINGS: 'vendor-exchange-settings',
  WORKFLOW: 'workflows',
  WORKING_HOURS: 'working-hours',
};
export const resourceState = {
  NULL: 0,
  STAFF: 1,
  LOCATION: 2,
  SERVICE: 3,
  CATEGORY: 4,
  ADDITIONAL_STAFF: 5,
};
export const SELECTION_COMMANDS = {
  CLIENT: 1,
  SERVICE: 2,
  LOCATION: 3,
  TIMES: 4,
  CLEAR_TIMES: 5,
  TIMEZONE: 6,
  CLEAR_ALL: 7,
};
export const states = {
  LIVE: 'live',
  PAID: 'paid',
};
export const TEMPLATE_ID = 'email-template';
export const staffDashboardVersions = {
  ONE: 1,
  TWO: 2,
};
export const RESOURCE = {
  CALL_CENTRE: 'contact_centre',
  HOURS: 'hours',
  LOBBY: 'lobby_view',
  SHORTCUTS: 'shortcuts',
  SCHEDULE: 'schedule',
};

export const SORTING = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
};

export const CLIENT_VIEW_LAYOUTS = {
  CLASSIC: 'old',
  MODERN: 'new',
};

export const DESTINATIONS = {
  HERE: 0,
  AWAY: 1,
  REMOTE: 2,
};

export const DESTINATION_LABELS = {
  [DESTINATIONS.HERE]: 'Destinations.business_location',
  [DESTINATIONS.AWAY]: 'Destinations.client_location',
  [DESTINATIONS.REMOTE]: 'Destinations.remote',
};

export const INTERVALS = {
  ONE_MINUTE: 60000,
  ONE_SECOND: 1000,
};

export const MEETING_METHODS = {
  AT_BUSINESS: 1,
  PHONE_CALL: 2,
  VIDEO_CALL: 3,
  OFF_SITE: 4,
};

export const MEETING_METHODS_NAMES = {
  [MEETING_METHODS.AT_BUSINESS]: 'MeetingMethods.in_person',
  [MEETING_METHODS.PHONE_CALL]: 'MeetingMethods.phone',
  [MEETING_METHODS.VIDEO_CALL]: 'MeetingMethods.video',
  [MEETING_METHODS.OFF_SITE]: 'MeetingMethods.off_site',
};

export const MEETING_METHOD_LABELS = {
  [MEETING_METHODS.AT_BUSINESS]: 'MeetingMethods.in_person_appointment',
  [MEETING_METHODS.PHONE_CALL]: 'MeetingMethods.phone_appointment',
  [MEETING_METHODS.VIDEO_CALL]: 'MeetingMethods.video_appointment',
  [MEETING_METHODS.OFF_SITE]: 'MeetingMethods.off_site_appointment',
};

export const MEETING_METHOD_LIST = [
  {
    id: String(MEETING_METHODS.AT_BUSINESS),
    attributes: {
      name: 'Shortcuts.meeting_method.at_location',
      description: 'MeetingMethods.business_description',
    },
  },
  {
    id: String(MEETING_METHODS.OFF_SITE),
    attributes: {
      name: 'Shortcuts.meeting_method.client_location',
      description: 'MeetingMethods.off_site_description',
    },
  },
  {
    id: String(MEETING_METHODS.PHONE_CALL),
    attributes: {
      name: 'Shortcuts.meeting_method.phone_call',
      description: 'MeetingMethods.phone_call_description',
    },
  },
  {
    id: String(MEETING_METHODS.VIDEO_CALL),
    attributes: {
      name: 'Shortcuts.meeting_method.video_call',
      description: 'MeetingMethods.video_call_description',
    },
  },
];

export const FULFILLMENT_METHODS = {
  WALK_IN: 1,
  CURBSIDE: 2,
};

export const FULFILLMENT_METHODS_NAMES = {
  [FULFILLMENT_METHODS.WALK_IN]: 'FulfillmentMethods.walk_in',
  [FULFILLMENT_METHODS.CURBSIDE]: 'FulfillmentMethods.curbside',
};

export const TOGGLE = {
  ON: 'on',
  OFF: 'off',
};

export const NOTIFICATION_EVENT_STATUSES = {
  ERROR: 1,
  SENDING: 2,
  FAILED: 3,
  SUCCESS: 4,
};

export const NOTIFICATION_OPTIONS = {
  REQUIRED: 'required',
  OPTIONAL: 'optional',
  HIDDEN: 'na',
};

export const WAIT_TIME = {
  SERVICE_LENGTH: 0,
  AVERAGE_HANDLE_TIME: 1,
};

export const VIRTUAL_MEETING_METHODS = [
  MEETING_METHODS.PHONE_CALL,
  MEETING_METHODS.VIDEO_CALL,
];

export const BUSINESS_HOURS_LINK =
  'https://help.coconutcalendar.com/en/articles/9802619-edit-a-location-s-business-hours';
export const WORKING_HOURS_LINK =
  'https://help.coconutcalendar.com/en/articles/9802614-add-working-hours-for-a-staff-member';
export const ADJUSTMENTS_LINK =
  'https://help.coconutcalendar.com/en/articles/9802618-how-to-adjust-hours';

export const SUPPORT_PHONE = '+1(888) 257-1309 x 2';
export const SUPPORT_PHONE_W_EXT = '+1(888)257-1309;ext=2';
export const EMERGENCY_EMAIL = 'emergency@coconutsoftware.com';
export const EMERGENCY_TELEPHONE = '+1(855) 980-5809';

export const ZENDESK_URL = 'https://coconutcalendar.zendesk.com/hc/en-us';
export const ZENDESK_UPDATES = `${ZENDESK_URL}/categories/360001732992-Coconut-Updates`;
export const ZENDESK_NEW_REQUEST = `${ZENDESK_URL}/requests/new`;

export const DEFAULT_COUNTRY = 'US';
export const POPULAR_COUNTRIES = ['CA', 'US'];
export const UNITED_STATES = 'US';

export enum VIDEO_PLATFORMS {
  MS_TEAMS = 1,
  ZOOM = 2,
  CONNECT = 3,
  OTHER = 4,
  EUV = 5,
}

export const VIDEO_PLATFORM_NAMES = {
  [VIDEO_PLATFORMS.MS_TEAMS]: 'teams',
  [VIDEO_PLATFORMS.ZOOM]: 'zoom',
  [VIDEO_PLATFORMS.CONNECT]: 'connect',
  [VIDEO_PLATFORMS.OTHER]: 'other',
  [VIDEO_PLATFORMS.EUV]: 'euv',
};

export const VIDEO_INTEGRATION_JOIN_LABELS = {
  [VIDEO_PLATFORMS.CONNECT]: 'VideoPlatforms.join_connect',
  [VIDEO_PLATFORMS.MS_TEAMS]: 'VideoPlatforms.join_teams',
  [VIDEO_PLATFORMS.ZOOM]: 'VideoPlatforms.join_zoom',
  [VIDEO_PLATFORMS.OTHER]: 'VideoPlatforms.join_call',
  [VIDEO_PLATFORMS.EUV]: 'VideoPlatforms.join_euv',
  null: 'VideoPlatforms.join_call',
};

export enum MS_GRAPH_INTEGRATIONS {
  VIDEO = 'video',
  MICROSOFT_ENTRA_ID = 'active-directory',
}

export const ORIGINS = {
  COCONUT: 0,
  MICROSOFT_ENTRA_ID: 1,
};

export const ORIGIN_LABELS = {
  [ORIGINS.COCONUT]: 'Label.coconut',
  [ORIGINS.MICROSOFT_ENTRA_ID]: 'Label.microsoft_entra_id',
};

export const uncategorizedId = 'uncategorized';

export const CallToActionTypes = {
  PHONE: '0',
  EMAIL: '1',
  WEBSITE: '2',
};

export const SHORTCUTS = {
  ADDITIONAL_STAFF: 'additional_staff',
};

export const NotificationChannels = {
  SMS: '1',
  EMAIL: '2',
};

export const REMINDER_TYPES = {
  SMS: 'sms',
  EMAIL: 'email',
  BOTH: 'both',
  COMPLETED_EMAIL: 'email_completed',
  EMAIL_STAFF_UPCOMING: 'email_staff_upcoming',
};

export const NOTIFICATION_RECIPIENT_TYPES = {
  USER: 'user',
  CLIENT: 'client',
};

export const DenylistedRecipientChannels = {
  EMAIL_CHANNEL: 1,
  SMS_CHANNEL: 2,
};

export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const dateFormat = 'YYYY-MM-DD';
export const time24HFormat = 'HH:mm:ss';
export const time12HFormat = 'h:mm A';

export const TEXT_FIELD_TYPE = {
  email: 'email',
  url: 'url',
  text: 'text',
};

export const UnitsOfTime = {
  DAY: 'days',
  HOUR: 'hours',
  WEEK: 'weeks',
  MINUTE: 'minutes',
};

export const URL_EVENT_APPOINTMENT_TYPE = 'appt';
export const URL_EVENT_QUEUE_APPOINTMENT_TYPE = 'queue';

export const URL_EVENT_TYPES = [
  URL_EVENT_APPOINTMENT_TYPE,
  URL_EVENT_QUEUE_APPOINTMENT_TYPE,
];

export const SCHEDULE_THEMES = {
  LIGHT_TEXT: 1,
  DARK_TEXT: 2,
};

export const APPOINTMENT_TYPES = {
  CLIENT: 0,
  GROUP: 2,
};

export const FEEDBACK_TYPES = {
  COCONUT: 0,
  CUSTOM: 1,
  GOOGLE: 2,
};

export const SCOPE = {
  MINE: 'MINE',
  ALL: 'ALL',
};

export const API_ERROR_CODES = {
  FAILED_TO_GENERATE_MEETING_LINK: 1000,
  CANNOT_HAVE_START_DATE_IN_THE_PAST: 1001,
  CANNOT_RESCHEDULE_MEETING_LINK: 1002,
  CANNOT_DELETE_MEETING_LINK: 1003,
};

export const LOOKER_EMBED_MANAGE_GROUP = 2;
export const LOOKER_EMBED_VIEW_GROUP = 3;

export const engagementStatuses = {
  CONFIRMED: 1,
  COMPLETE: 2,
  NO_SHOW: 3,
  CANCELLED: 4,
  IN_PROGRESS: 5,
};

export const DOCUMENT_PROVIDERS = {
  DOCUSIGN: 1,
  ONESPAN: 2,
};

export const SCHEDULE_TYPE = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const RELEASE_STATUS = {
  DEV: 'dev',
  ALPHA: 'alpha',
  BETA: 'beta',
  GENERAL: 'general',
};

export const ADD_NEW_FROM_ANYWHERE = 'add_new_from_anywhere';

export const MODE = {
  COCONUT: 'coconut',
  DYNAMICS: 'dynamics',
};

export const INTEGRATION_MODES = [MODE.DYNAMICS];

export const INTEGRATION_POST_MESSAGES = {
  APPOINTMENT_BOOKED: 'appointment_booked',
  APPOINTMENT_CANCELLED: 'appointment_cancelled',
  APPOINTMENT_UPDATED: 'appointment_updated',
};

export const PHONE_TYPES = {
  phone: 'phone',
  cell_phone: 'cell_phone',
  work_phone: 'work_phone',
};

export const TOLL_FREE_VERIFICATION_STATUSES = {
  PENDING: 1,
  IN_REVIEW: 2,
  APPROVED: 3,
  REJECTED: 4,
};

export const TAG_MANAGER_GOOGLE = 'google_tag_manager';
export const TAG_MANAGER_TEALIUM = 'tealium_tag_manager';
export const TAG_MANAGER_ADOBE = 'adobe_launch';

export const TAG_MANAGERS = {
  [TAG_MANAGER_GOOGLE]: 1,
  [TAG_MANAGER_TEALIUM]: 2,
  [TAG_MANAGER_ADOBE]: 3,
};

export const DEFAULT_PRIMARY_PHONE_TYPE = 'cell_phone';

export const ADD_NEW_USE_CONTACT_CENTRE = 'contact_centre';

export const ADD_NEW_USE_SCHEDULE = 'schedule';

export const OLD_JS_PATHS = [
  '/services',
  '/staff/settings',
  '/settings/api',
  '/settings/questions',
  '/settings/payments',
  '/vendors',
];

export const CHAT_TYPE = {
  ADVISOR: 1,
  LIVE_AGENT: 2,
};
export const ENGAGEMENTS_PAGINATION_LIMIT = 20;

export const CRM = {
  SALESFORCE: 'salesforce',
};

export const LOOKER_EXPORT_STATUS_INTL_IDS = {
  0: 'AdvancedAnalytics.sftp.scheduled',
  1: 'AdvancedAnalytics.sftp.in_progress',
  2: 'AdvancedAnalytics.sftp.completed',
  3: 'AdvancedAnalytics.sftp.failed',
  4: 'AdvancedAnalytics.sftp.cancelled',
  5: 'AdvancedAnalytics.sftp.no_looker_user',
  6: 'AdvancedAnalytics.sftp.user_archived',
};

export const LAYOUT_SYNC_STATUS = {
  NOT_STARTED: 0,
  STARTED: 1,
  ERROR: 2,
  PARTIAL_ERROR: 3,
  SUCCESS: 4,
};

export const VIDEO_ACCESS_CODE_LENGTH = 9;

export const remoteAvailabilityStatus = {
  ON: 1,
  OFF: 0,
};

export const NOTIFICATION_EXCLUSION_TYPES = {
  SERVICE: 'App\\Models\\Service',
  STAFF: 'staff_notifications',
  CLIENT: 'client_notifications',
};

export enum SETTINGS {
  ADD_NEW_LOCATION = 'add_new_location',
  ADMIN_TIME_IN_ADVANCE = 'admin_time_in_advance',
  ALLOW_MULTIPLE_ATTENDEES = 'allow_multiple_attendees',
  API_EXPIRES_IN = 'api_expires_in',
  ASSIGN_NEW_USERS_TO_MANAGER_LOCATIONS = 'assign_new_users_to_manager_locations',
  ASSIGN_SERVICES_BY_STAFF_GROUP = 'assign_services_by_staff_group',
  BACKEND_CLIENT_FIELDS = 'backend_client_fields',
  BOOKING_SHORTCUT_CUSTOM_EXPIRED_MESSAGE = 'booking_shortcut_custom_expired_message',
  BRANCH_LOCATOR_LOCATION_SEARCH_RADIUS = 'branch_locator_location_search_radius',
  CALLBACK_CLOSED_LOCATION_INFO = 'callback_closed_location_info',
  CALLBACK_CONTACT_OPTIONS = 'callback_contact_options',
  CLIENT_FIELDS = 'client_fields',
  CLIENT_NOTIFICATIONS_ICS_ADD_ATTENDEES = 'client_notifications_ics_add_attendees',
  CLIENT_NOTIFICATIONS_ICS = 'client_notifications_ics',
  CLIENT_VIEW_WITHOUT_BOOKING_SHORTCUT = 'client_view_without_booking_shortcut',
  CLIENT_VIEW = 'client_view',
  CLIENTS_BCC_EMAIL = 'clients_bcc_email',
  CONNECT_ACCESS_MEETING_DETAILS = 'connect_access_meeting_details',
  CONNECT_ADD_PRIVATE_NOTES = 'connect_add_private_notes',
  CONNECT_ADMIT_PARTICIPANTS = 'connect_admit_participants',
  CONNECT_CHAT_FEATURE = 'connect_chat_feature',
  CONNECT_CONTROL_CO_BROWSING = 'connect_control_co_browsing',
  CONNECT_CONTROL_E_SIGNATURE = 'connect_control_e_signature',
  CONNECT_CONTROL_UPLOADED_DOCUMENT_REVIEW = 'connect_control_uploaded_document_review',
  CONNECT_INVITE_PARTICIPANTS = 'connect_invite_participants',
  CONNECT_MARK_NO_SHOW_WALK_IN = 'connect_mark_no_show_walk_in',
  CONNECT_REMOVE_PARTICIPANTS = 'connect_remove_participants',
  CONNECT_SCREEN_SHARING = 'connect_screen_sharing',
  CONNECT_SCREEN_SHARING_FEATURE = 'connect_screen_sharing_feature',
  CONNECT_TURN_OFF_REMOTE_MEDIA = 'connect_turn_off_remote_media',
  CONNECT_VERIFY_IDENTITIES = 'connect_verify_identities',
  CONTACT_CENTRE_INVITE_ONLY_LOCATIONS = 'contact_centre_invite_only_locations',
  CONTACT_CENTRE_INVITE_ONLY_SERVICES = 'contact_centre_invite_only_services',
  CONTACT_CENTRE_INVITE_ONLY_STAFF = 'contact_centre_invite_only_staff',
  CONTACT_CENTRE_PRIVATE_LOCATIONS = 'contact_centre_private_locations',
  CONTACT_CENTRE_PRIVATE_SERVICES = 'contact_centre_private_services',
  CONTACT_CENTRE_PRIVATE_STAFF = 'contact_centre_private_staff',
  COOP_CLIENT_ID = 'coop_client_id',
  COOP_CLIENT_SECRET = 'coop_client_secret',
  COOP_ENABLED = 'coop_enabled',
  COPY_MULTIPLE_ATTENDEES_ANSWERS = 'copy_multiple_attendees_answers',
  CREDIT_CARD_CAPTURE = 'credit_card_capture',
  CURRENCY = 'currency',
  CUSTOM_BRANCH_LOCATOR_ATM_PIN_COLOR = 'custom_branch_locator_atm_pin_color',
  CUSTOM_BRANCH_LOCATOR_ATM_PIN_UPLOAD_ID = 'custom_branch_locator_atm_pin_upload_id',
  CUSTOM_BRANCH_LOCATOR_GENERAL_PIN_COLOR = 'custom_branch_locator_general_pin_color',
  CUSTOM_BRANCH_LOCATOR_GENERAL_PIN_UPLOAD_ID = 'custom_branch_locator_general_pin_upload_id',
  CUSTOM_KIOSK_REDIRECT = 'custom_kiosk_redirect',
  DEFAULT_CLIENT_VIEW_LANGUAGE = 'default_client_view_language',
  EMAIL_INSTRUCTIONS_ALT_POSITION_SETTING = 'email_instructions_alt_position_setting',
  EXPLICIT_COMPLIANCE_AGREEMENT = 'explicit_compliance_agreement',
  FEEDBACK_TYPE = 'feedback_type',
  FEEDBACK_URL = 'feedback_url',
  FIRST_STEP = 'first_step',
  FLOATING_REMINDERS = 'floating_reminders',
  FRAME_ANCESTORS = 'frame_ancestors',
  GOOGLE_LOGIN_ENABLED = 'google_login_enabled',
  GOOGLE_RECAPTCHA_API_KEY = 'google_recaptcha_api_key',
  GOOGLE_RECAPTCHA_MIN_SCORE = 'google_recaptcha_min_score',
  GOOGLE_RECAPTCHA_PROJECT_ID = 'google_recaptcha_project_id',
  GOOGLE_RECAPTCHA_SITE_KEY = 'google_recaptcha_site_key',
  GOOGLE_TAG_MANAGER_CODE = 'google_tag_manager_code',
  GRAPH_SHOW_EVENT_TITLES = 'graph_show_event_titles',
  GTM_CONFIGURATION = 'gtm_configuration',
  HIDE_LOCATION_HOURS = 'hide_location_hours',
  HOMEPAGE = 'homepage',
  INCLUDE_LOCATION_STEP = 'include_location_step',
  INTERVAL_TYPE = 'interval_type',
  INTERVAL = 'interval',
  JOIN_LINE_FROM_CLIENT_VIEW = 'join_line_from_client_view',
  KIOSK_APPOINTMENT_BOOKING = 'kiosk_appointment_booking',
  KIOSK_QR_CODE = 'kiosk_qr_code',
  KIOSK_SELECT_PREFERRED_LANG = 'kiosk_select_preferred_lang',
  KIOSK_SELECT_PREFERRED_STAFF = 'kiosk_select_preferred_staff',
  KIOSK_SHOW_CUSTOM_MESSAGE = 'kiosk_show_custom_message',
  LANGUAGE_ORDERING = 'language_ordering',
  LOBBY_ALLOW_STAFF_STATUS_UPDATES = 'lobby_allow_staff_status_updates',
  LOBBY_AUTO_NOTIFY_NEXT_IN_LINE = 'lobby_auto_notify_next_in_line',
  LOBBY_IN_PROGRESS_EVENTS = 'lobby_in_progress_events',
  LOBBY_NOTIFY = 'lobby_notify',
  LOBBY_RESTRICT_LOCATIONS = 'lobby_restrict_locations',
  LOBBY_STAFF_AVAILABILITY_ROLE = 'lobby_staff_availability_role',
  LOCATION_SEARCH_RADIUS = 'location_search_radius',
  MANAGER_STAFF_TABLE_VIEW = 'manager_staff_table_view',
  MCV_CUSTOM_CONTACT = 'mcv_custom_contact',
  MCV_SHOW_LOCATION_PHONE_CALL_TO_ACTION = 'mcv_show_location_phone_call_to_action',
  MEETING_METHOD_ORDERING = 'meeting_method_ordering',
  MULTIPLE_ATTENDEES_LIMIT = 'multiple_attendees_limit',
  MULTI_SERVICE_WALKINS = 'multi_service_walkins',
  NOTIFICATION_EXCLUSIONS = 'notification_exclusions',
  NOTIFICATIONS_ATTENDEE_ANSWERS_CLIENT = 'notifications_attendee_answers_client',
  NOTIFICATIONS_ATTENDEE_ANSWERS_STAFF = 'notifications_attendee_answers_staff',
  NOTIFICATIONS_ATTENDEE_INFO_CLIENT = 'notifications_attendee_info_client',
  NOTIFICATIONS_ATTENDEE_INFO_STAFF = 'notifications_attendee_info_staff',
  NOTIFICATIONS_CHECK_IN_EMAIL_CLIENT = 'notifications_check_in_email_client',
  NOTIFICATIONS_CHECK_IN_EMAIL_STAFF = 'notifications_check_in_email_staff',
  NOTIFICATIONS_CHECK_IN_SMS_CLIENT = 'notifications_check_in_sms_client',
  NOTIFICATIONS_CHECK_IN_SMS_STAFF = 'notifications_check_in_sms_staff',
  NOTIFICATIONS_COCONUT_CONNECT_STAFF = 'notifications_coconut_connect_staff',
  NOTIFICATIONS_COMPLETED_EMAIL = 'notifications_completed_email',
  NOTIFICATIONS_COMPLETED_SMS = 'notifications_completed_sms',
  NOTIFICATIONS_GENERAL_EMAIL_CLIENT = 'notifications_general_email_client',
  NOTIFICATIONS_GENERAL_EMAIL_STAFF = 'notifications_general_email_staff',
  NOTIFICATIONS_GENERAL_SMS_CLIENT = 'notifications_general_sms_client',
  NOTIFICATIONS_GENERAL_SMS_STAFF = 'notifications_general_sms_staff',
  NOTIFICATIONS_LOBBY_EMAILS = 'notifications_lobby_emails',
  NOTIFICATIONS_LOCATION_BASED_ADMIN_AND_MANAGER = 'notifications_location_based_admin_and_manager',
  NOTIFICATIONS_LOCATION_ESCALATION_EMAIL = 'notifications_location_escalation_email',
  NOTIFICATIONS_LOCATION_ESCALATION_SMS = 'notifications_location_escalation_sms',
  NOTIFICATIONS_MISSED_EMAIL = 'notifications_missed_email',
  NOTIFICATIONS_MISSED_LINK = 'notifications_missed_link',
  NOTIFICATIONS_MISSED_SMS = 'notifications_missed_sms',
  NOTIFICATIONS_STAFF_INFO_CLIENT = 'notifications_staff_info_client',
  NOTIFICATIONS_WALK_IN_ADDED_EMAIL_LOCATION = 'notifications_walk_in_added_email_location',
  NOTIFICATIONS_WALK_IN_ADDED_EMAIL_STAFF = 'notifications_walk_in_added_email_staff',
  NOTIFICATIONS_WALK_IN_ADDED_SMS_LOCATION = 'notifications_walk_in_added_sms_location',
  NOTIFICATIONS_WALK_IN_ADDED_SMS_STAFF = 'notifications_walk_in_added_sms_staff',
  PRIMARY_PHONE_TYPE = 'primary_phone_type',
  REORDER_SPECIFIC_STAFF_BEFORE_LANGUAGES = 'reorder_specific_staff_before_languages',
  RESERVE_WITH_GOOGLE = 'reserve_with_google',
  SERVICE_STEP_LAYOUT = 'service_step_layout',
  SHOW_BRANCH_LOCATOR_ATM_STYLING_PICKER = 'show_branch_locator_atm_styling_picker',
  SHOW_BRANCH_LOCATOR_GENERAL_STYLING_PICKER = 'show_branch_locator_general_styling_picker',
  SHOW_CALLBACK_WAIT_TIME = 'show_callback_wait_time',
  SHOW_CUSTOM_CANCELLATION_MESSAGE = 'show_custom_cancellation_message',
  SHOW_CUSTOM_RESCHEDULING_MESSAGE = 'show_custom_rescheduling_message',
  SHOW_FULL_USER_NAME = 'show_full_user_name',
  SHOW_JOB_TITLES = 'show_job_titles',
  SHOW_PAST_WALKINS = 'show_past_walkins',
  SHOW_QUEUE_APPOINTMENT_FEEDBACK = 'show_queue_appointment_feedback',
  SHOW_SMS_CONFIRMATION_WAIT_TIME = 'show_sms_confirmation_wait_time',
  SHOW_STAFF_ASSIGNED = 'show_staff_assigned',
  SHOW_STAFF_LANGUAGES = 'show_staff_languages',
  SHOW_STAFF_PHOTOS = 'show_staff_photos',
  SHOW_STAFF_PICKER = 'show_staff_picker',
  SHOW_TV_QR_CODE = 'show_tv_qr_code',
  SHOW_TV_WAIT_TIME = 'show_tv_wait_time',
  SHOW_WAIT_TIME_ON_CLIENT_VIEW = 'show_wait_time_on_client_view',
  SORT_STAFF_NIGHTLY = 'sort_staff_nightly',
  STAFF_ENGAGEMENT_SMS_CONSENT_PROMPT = 'staff_engagement_sms_consent_prompt',
  STAFF_NOTIFICATIONS_ICS = 'staff_notifications_ics',
  STAFF_SELECTION = 'staff_selection',
  SUPPORT_CONTACT_IS_VISIBLE = 'support_contact_is_visible',
  SUPPORT_IS_VISIBLE = 'support_is_visible',
  TIME_IN_ADVANCE = 'time_in_advance',
  TIME_TO_BOOK = 'time_to_book',
  TIME_TO_BOOK_GROUP = 'time_to_book_group',
  TIME_TO_CANCEL = 'time_to_cancel',
  TIME_TO_RESCHEDULE = 'time_to_reschedule',
  USE_REBOOK_LINK_SETTINGS = 'use_rebook_link_settings',
  USE_NEAREST_LOCATION = 'use_nearest_location',
  USE_STAFF_SPOKEN_LANGUAGES = 'use_staff_spoken_languages',
  USE_THEME_ON_TV = 'use_theme_on_tv',
  USE_TV_TOKEN = 'use_tv_token',
  USE_VENDOR_SUPPORTED_LANGUAGES = 'use_vendor_supported_languages',
  VENDOR_SUPPORTED_LANGUAGES = 'vendor_supported_languages',
  WAIT_LIST_EMAIL = 'wait_list_email',
  WAIT_TIME_ON_LOGIN = 'wait_time_on_login',
  WAIT_TIME_TYPE = 'wait_time_type',
  WALKIN_QUESTIONS = 'walkin_questions',
  WORKFLOW_MANAGEMENT = 'workflow_management',
}

export const DASHBOARD_GREETING_MESSAGE_IDS = [
  'StaffDashboard.summary.greeting.checkInProgress',
  'StaffDashboard.summary.greeting.dayAtAGlance',
  'StaffDashboard.summary.greeting.doingGreat',
  'StaffDashboard.summary.greeting.greatWork',
  'StaffDashboard.summary.greeting.orchestratingGreatness',
  'StaffDashboard.summary.greeting.reviewActivity',
  'StaffDashboard.summary.greeting.schedulingOlympics',
  'StaffDashboard.summary.greeting.seeWhatsAhead',
  'StaffDashboard.summary.greeting.todaysPlan',
  'StaffDashboard.summary.greeting.youveGotThis',
];

export const REACT_PAGES = [
  '/analytics-lite',
  '/booking-shortcuts',
  '/booking-shortcuts/create',
  '/booking-shortcuts/edit/*',
  '/conversations*',
  '/dashboard',
  '/groups',
  '/hours/*',
  '/insights',
  '/locations',
  '/chats*',
  '/clients',
  '/forbidden',
  '/lobby',
  '/manage-analytics-roles',
  '/manage-features',
  '/manage-features/create',
  '/manage-features/*/edit',
  '/meetings/salesforce/*',
  '/mtls-credentials',
  '/lines-of-business*',
  '/points',
  '/reports',
  '/report_templates',
  '/rooms',
  '/synonyms-management',
  '/cx-snippets-management',
  '/ip-management',
  '/seed-demo-data',
  ...(window.initialState?.vendor?.featureDecisions
    .shouldShowNewServicesDatatable
    ? ['/services']
    : []),
  '/settings/access/roles/*',
  '/settings/admin-view',
  '/settings/api',
  '/settings/branding/general',
  '/settings/branding/email',
  '/settings/contact-centre',
  '/settings/coconut-connect',
  '/settings/conversations',
  '/settings/client-view',
  '/settings/lobby',
  '/settings/notifications/client',
  '/settings/notifications/staff',
  '/settings/crm',
  '/settings/sso',
  '/settings/e-signatures',
  '/settings/integrations/*',
  '/settings/branch-locator',
  '/settings/categories/*',
  '/settings/client-view',
  '/settings/lobby',
  '/settings/conversations',
  '/settings/crm/*',
  '/settings/data',
  '/settings/digital-banking/*',
  '/settings/e-signatures',
  '/settings/exchange/*',
  '/settings/glia',
  '/settings/google-calendar/*',
  '/settings/integrations/*',
  '/settings/microsoft-entra-id',
  '/settings/notifications/client',
  '/settings/notifications/location',
  '/settings/notifications/staff',
  '/settings/reserve',
  '/settings/sso',
  '/settings/video-calls',
  '/settings/data',
  '/settings/glia',
  '/settings/support',
  '/settings/webhooks',
  '/staff',
  '/staff/*/assignments/edit',
  '/advanced_analytics',
  '/schedule',
  ...(window.initialState?.vendor?.featureDecisions.shouldShowNewActivitiesPage
    ? ['/clients/*/appointments']
    : []),
  ...(window.initialState?.vendor?.featureDecisions.shouldShowNewActivitiesPage
    ? ['/clients/*/timeline']
    : []),
  ...(window.initialState?.vendor?.featureDecisions.shouldShowNewActivitiesPage
    ? ['/clients/*/walk-ins']
    : []),
  ...(window.initialState?.vendor?.featureDecisions.shouldShowNewActivitiesPage
    ? ['/clients/*/workflows']
    : []),
  ...(window.initialState?.vendor?.featureDecisions
    .shouldUseNewCategoriesManagement
    ? ['/settings/categories']
    : []),
  ...(window.initialState?.vendor?.featureDecisions
    .shouldUseNewCategoriesManagement
    ? ['/settings/categories/create']
    : []),
  ...(window.initialState?.vendor?.featureDecisions
    .shouldUseNewCategoriesManagement
    ? ['/settings/categories/*/edit']
    : []),
  ...(window.initialState?.vendor?.featureDecisions
    .shouldUseRoleBasedAccessControl
    ? ['/settings/access/roles']
    : []),
];
